import { Box } from '@chakra-ui/react';

export const TrendingIconDownSVG = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <Box>
      <svg width="30" height="31" viewBox="11 11 8 9" fill="none" {...props}>
        <path
          d="M11.6665 12.1666L18.3332 18.8333"
          stroke="#2D6670"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.3332 12.1666V18.8333H11.6665"
          stroke="#2D6670"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Box>
  );
};

export default TrendingIconDownSVG;
